export default "__VITE_PUBLIC_ASSET__fc7441ea__"